import { useNavigate } from 'react-router-dom'
import { useUserRole } from '@/hooks/useUserRole'
import { buildProfileMessagesHref } from '@/features/user-profile/utils/messageCenterHelpers'
import { canViewProfileMessages } from '@/features/user-profile/utils/profileMessagesAccess'
import type { SeeMoreMessagesLinkProps } from '../types/notification'

export function SeeMoreMessagesLink({
  kind,
  id,
  onNavigate,
}: SeeMoreMessagesLinkProps) {
  const navigate = useNavigate()
  const { roleName } = useUserRole()

  if (!canViewProfileMessages(roleName)) return null

  return (
    <button
      type="button"
      data-testid="notification-see-more-link"
      className="mt-3 text-sm font-semibold text-[rgb(21_151_255)] hover:underline"
      onClick={() => {
        onNavigate?.()
        navigate(buildProfileMessagesHref(kind, id))
      }}
    >
      See more
    </button>
  )
}
